
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Sorting} from './Sorting';
import {FieldModelSorting} from './Sorting';

/**
 * SocialTradingOrderInvestorSorting struct
 */
class SocialTradingOrderInvestorSorting {
  /**
   * Initialize struct
   * @param {Sorting=} masterOrderId
   * @param {Sorting=} masterLogin
   * @constructor
   */
  constructor (masterOrderId = null, masterLogin = null) {
    this.MasterOrderId = masterOrderId
    this.MasterLogin = masterLogin
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SocialTradingOrderInvestorSorting}
   * @param {!SocialTradingOrderInvestorSorting} other Other struct
   * @returns {!SocialTradingOrderInvestorSorting} This struct
   */
  copy (other) {
    if (other.MasterOrderId != null) {
      this.MasterOrderId = Sorting.fromObject(other.MasterOrderId)
    } else {
      this.MasterOrderId = null
    }
    if (other.MasterLogin != null) {
      this.MasterLogin = Sorting.fromObject(other.MasterLogin)
    } else {
      this.MasterLogin = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SocialTradingOrderInvestorSorting}
   * @returns {!SocialTradingOrderInvestorSorting} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SocialTradingOrderInvestorSortingModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SocialTradingOrderInvestorSortingModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SocialTradingOrderInvestorSorting}
   * @param {!SocialTradingOrderInvestorSorting} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingOrderInvestorSorting)) {
      throw new TypeError('Instance of SocialTradingOrderInvestorSorting is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SocialTradingOrderInvestorSorting}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      MasterOrderId: ((this.MasterOrderId != null) ? this.MasterOrderId : null),
      MasterLogin: ((this.MasterLogin != null) ? this.MasterLogin : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SocialTradingOrderInvestorSorting.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SocialTradingOrderInvestorSorting} other Object value
   * @returns {!SocialTradingOrderInvestorSorting} Created struct
   */
  static fromObject (other) {
    return new SocialTradingOrderInvestorSorting().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SocialTradingOrderInvestorSorting}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SocialTradingOrderInvestorSorting.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SocialTradingOrderInvestorSorting}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 166
  }
}

export { SocialTradingOrderInvestorSorting };

/**
 * Fast Binary Encoding SocialTradingOrderInvestorSorting field model
 */
class FieldModelSocialTradingOrderInvestorSorting extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.MasterOrderId = new fbe.FieldModelOptional(new FieldModelSorting(buffer, 4 + 4), buffer, 4 + 4)
    this.MasterLogin = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.MasterOrderId.fbeOffset + this.MasterOrderId.fbeSize), buffer, this.MasterOrderId.fbeOffset + this.MasterOrderId.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.MasterOrderId.fbeSize + this.MasterLogin.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.MasterOrderId.fbeExtra + this.MasterLogin.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSocialTradingOrderInvestorSorting.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 166
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.MasterOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MasterOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterOrderId.fbeSize

    if ((fbeCurrentSize + this.MasterLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MasterLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterLogin.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @param {!SocialTradingOrderInvestorSorting} fbeValue Default value, defaults is new SocialTradingOrderInvestorSorting()
   * @returns {!SocialTradingOrderInvestorSorting} SocialTradingOrderInvestorSorting value
   */
  get (fbeValue = new SocialTradingOrderInvestorSorting()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @param {!SocialTradingOrderInvestorSorting} fbeValue SocialTradingOrderInvestorSorting value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.MasterOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.MasterOrderId = this.MasterOrderId.get()
    } else {
      fbeValue.MasterOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterOrderId.fbeSize

    if ((fbeCurrentSize + this.MasterLogin.fbeSize) <= fbeStructSize) {
      fbeValue.MasterLogin = this.MasterLogin.get()
    } else {
      fbeValue.MasterLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterLogin.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @param {!SocialTradingOrderInvestorSorting} fbeValue SocialTradingOrderInvestorSorting value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSocialTradingOrderInvestorSorting}
   * @param {SocialTradingOrderInvestorSorting} fbeValue SocialTradingOrderInvestorSorting value
   */
  setFields (fbeValue) {
    this.MasterOrderId.set(fbeValue.MasterOrderId)
    this.MasterLogin.set(fbeValue.MasterLogin)
  }
}

export { FieldModelSocialTradingOrderInvestorSorting };

/**
 * Fast Binary Encoding SocialTradingOrderInvestorSorting model
 */
class SocialTradingOrderInvestorSortingModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSocialTradingOrderInvestorSorting(this.buffer, 4)
  }

  /**
   * Get the SocialTradingOrderInvestorSorting model
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @returns {!FieldModelSocialTradingOrderInvestorSorting} model SocialTradingOrderInvestorSorting model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SocialTradingOrderInvestorSortingModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSocialTradingOrderInvestorSorting.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @param {!SocialTradingOrderInvestorSorting} value SocialTradingOrderInvestorSorting value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @param {!SocialTradingOrderInvestorSorting} value SocialTradingOrderInvestorSorting value, defaults is new SocialTradingOrderInvestorSorting()
   * @return {!object} Deserialized SocialTradingOrderInvestorSorting value and its size
   */
  deserialize (value = new SocialTradingOrderInvestorSorting()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SocialTradingOrderInvestorSorting(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SocialTradingOrderInvestorSorting(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SocialTradingOrderInvestorSortingModel}
   * @param {!number} prev Previous SocialTradingOrderInvestorSorting model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SocialTradingOrderInvestorSortingModel };
